module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/content.component.html
// module id = ../../../../../src/app/main/content/content.component.html
// module chunks = main